import EventBus from "./LiveCore/event";

export interface ILiveDelegate{
	/**
	 * isAudience，是否是观众
	 */
	isAudience: boolean;
	/**
	 * 演示者的激光笔是否打开
	 */
	isRemoteLaserOn: boolean;
	getRemotePoint(): Array<any>;
	onLaserPenMoved(evt: IPenMoveEvent):any;
	enableLive: boolean;
	allowFlip(): boolean;
	setAllowFlip(allow: boolean): void;
	event: EventBus;
	role: LiveRoleType;
	liveInfo: ILiveInfo;
	masterName: string;
	memberCount: number;
	memberList: Array<any>;
	liveBegin(eventArgs: any): boolean;
	closeShowRoom(): void;
	createShow(callback: Function): void;
	masterEnter(): void;

	getAsyncInfo: string; //获取观看者翻页后，演示者的演示状态信息。
	/**判断观看者是否已经手动翻页 */
	isManulFlipped: boolean;  
	
}

export enum MediaCmd {
    /** 播放 */
    PLAY = 'play',
    /** 暂停 */
    PAUSE = 'pause',
    /** 快进/后退 */
    SEEK = 'seek',
    /** 倍速 */
    SPEED = 'speed',
}

export interface IMediaSyncInfo {
    /** mediaId */
    mediaId: string;
    /** media 命令 */
    cmd: MediaCmd,
    /** 播放时间 */
    playtime: number;
    /** 播放速度 */
    speed?: number;
}

export interface ILiveInfo {
	state: LiveState; // 直播状态
	name: string; //演示者昵称
	points: string, // 激光笔数据
	page: number;	// 页
	fragment: number; // 节
	allow_flip: AllowFlipState; //允许翻页状态
	revision: number;
	confid: string;	// 语音房间号
	confmsg: string; // 语音房间透传消息
	extra?: string; // 附加信息
	info?: string; // createShow 时自定义的透传字段
	iaFragmentInfo?: string; // 触发器动画信息
    shouldStopMainAnim?: boolean; // 中断主队列动画标识（用于每一页最后一个主队列动画）
    media?: IMediaSyncInfo;
    isLoadPageBySwitchForward?: boolean; // true 向上翻页；false 向下翻页或者通过缩略图跳页
	/** 暂停动画 */
	shouldStopTransition?: boolean;
}
export interface IPenMoveDetail {
	X: number;
	Y: number;
	W: number;
	H: number;
	p: number;
	f: number;
}
export interface IPenMoveEvent {
	details: IPenMoveDetail;
}

// ToolBarEvents
export enum IPlayerEvent {
	Null = 'Null',							// 占位
	Prev = 'Prev',							// 上一页
	Next = 'Next',							// 下一页
	FullScreen = 'FullScreen',				// 全屏
	Exit = 'Exit',							// 退出
	ShowLiveDialog = 'ShowLiveDialog',		// 显示创建演示房间弹窗
	ShowMemberList = 'ShowMemberList',		// 显示观看者列表
	CreateMeeting = 'CreateMeeting',		// 创建通话房间
	DissloveMeeting = 'DissloveMeeting',	// 解散语音通话
	JoinMeeting = 'JoinMeeting',			// 加入通话
	QuitMeeting = 'QuitMeeting',			// 退出通话
	MicrophoneOn = 'MicrophoneOn',			// 麦克风（开启/关闭）
	MicrophoneOff = 'MicrophoneOff',			
	Laser = 'Laser',						// 激光笔（ToolBar外部去控制开关状态）
	NeedNewUserTip = 'NeedNewUserTip',		// 是否显示新用户Tips（需要外部去判断是否显示，并且将结果作为bool返回）
	StartLiving = 'StartLiving',			// 本地播放开启演示
	ShowInvite = 'ShowInvite',				// 显示邀请成员
	CopyLink = 'CopyLink',					// 复制远程演示链接
	AudienceFlip = 'AudienceFlip',			// 允许观看者翻页
	Mute = 'Mute',							// 主持人禁言
	AllMute = 'AllMute',					// 全场静音
	SyncWithMaster = 'SyncWithMaster',		// 跳转至正在演示页面
	ShowPopWindow = 'ShowPopWindow',		// popWindow出现/消失
	MeetingLogin = 'MeetingLogin',			// 登录会议SDK
	ToggleNote = 'ToggleNote',				// 点击了备注切换按钮
	ZoomIn = 'ZoomIn',						// 放大按钮
	ZoomOut = 'ZoomOut',					// 缩小按钮
	ToggleView = 'ToggleView',              // 切换视图(普通/演讲者)
	OpenPresenterViewWindow = 'OpenPresenterViewWindow',  // 打开独立演讲者视图弹窗
}

export enum LiveButtonEvent {
	Null = 'Null',							// 占位
	LiveButtonClicked = 'LiveButtonClicked',// 点击演示按钮
	StartLocalPlay = 'StartLocalPlay',		// 开启本地播放
	CreateRoom = 'CreateRoom',				// 创建演示房间
	StartLiving = 'StartLiving',			// 本地播放开启演示
	CopyLink = 'CopyLink',					// 复制远程演示链接
	CloseRoom = 'CloseRoom',				// 关闭演示房间
	AudienceFlip = 'AudienceFlip',			// 允许观看者翻页
}

// LiveEvents
/**
 * 
 */
export const ClientReady: string = 'ClientReady';
/**
 * 直播房间状态变化
 */
export const LiveStateChanged: string = 'LiveStateChanged';
/**
 * 演示房间成员发生变化
 */
export const MemberChanged: string = 'UserChanged';
/**
 * 即将开始播放
 */
export const LiveWillBegin: string = 'LiveWillBegin';
/**
 * 开始播放
 */
export const LiveBegin: string = 'LiveBegin';
/**
 * 开始播放
 */
export const LiveDidBegin: string = 'LiveDidBegin';
/**
 * 翻页消息
 */
export const PageChanged: string = 'PageChanged';
/**
 * 允许翻页消息
 */
export const AllowFlipChanged: string = 'AllowFlipChanged';
/**
 * 语音房间号
 */
export const MeetingCodeChanged: string = 'MeetingCodeChanged';
/**
 * 语音房间信息
 */
export const MeetingInfoChanged: string = 'MeetingInfoChanged';
/**
 * 房间初始信息同步
 */
export const RoomNewInfoChanged: string = 'RoomNewInfoChanged';
/**
 * 房间满员，降级为 http 轮询
 */
export const FallbackToPolling: string = 'FallbackToPolling';
/** 
 * 演示 socket shutdown 
 */
export const LiveSocketShutDown = 'LiveSocketShutDown';
/**
 * 本地激光笔
 */
export const LaserURL: string = 'url("https://pub.idqqimg.com/pc/misc/files/20201113/e90425b3d2743874d580fe742ca6df43.ico") 16 16, auto';

/**
 * 音视频状态发生变化：play/pause/seek/speed
 */
export const MediaStateChanged: string = 'MediaStateChanged';


/**
 * 直播中的角色，演讲者、观众
 */
export enum LiveRoleType {
	None = 0, // 没有直播
	Master = 1, // 演讲者
	Audience = 2, // 观众
}
/**
 * 直播状态，直播中、暂停、结束
 */
export enum LiveState {
	None = 0, // 保留值
	OnAir = 1, // 正在直播
	Pause = 2, // 等待开始 & 暂停
	Ended = 3, // 直播结束
}
/**
 * 是否允许观众翻页：YES、NO
 */
export enum AllowFlipState {
	None = 0, //保留
	YES = 2,
	NO = 1,
}